module.exports = __webpack_public_path__ + "static/lights39-fac6c63c471e8c15cfb292ef99bea7bf.jpg";